import React from "react";
import RemoteSelect2 from "../remoteSelect2";
import MultiRemoteSelect from "../multiRemoteSelect";

const splitListValue = (value) =>
  String(value ?? "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

const McaConditionRefValueInput = ({
  label = "Value",
  refConfig,
  conditionType,
  value,
  onChange,
  disabled = false,
}) => {
  if (!refConfig?.apiEntity) {
    return null;
  }

  const multiple = conditionType === "$in";
  const {
    apiEntity,
    valueField = "_id",
    labelField = "name",
    labelRender,
    preQuery,
    searchFields,
    sort,
    pageSize = 20,
  } = refConfig;

  if (multiple) {
    return (
      <MultiRemoteSelect
        label={label}
        apiEntity={apiEntity}
        valueField={valueField}
        labelField={labelField}
        labelRender={labelRender}
        preQuery={preQuery}
        searchFields={searchFields}
        sort={sort}
        pageSize={pageSize}
        value={splitListValue(value)}
        placeholder="Select one or more"
        disabled={disabled}
        onChange={(ids) => onChange((ids ?? []).join(", "))}
      />
    );
  }

  return (
    <RemoteSelect2
      label={label}
      apiEntity={apiEntity}
      valueField={valueField}
      labelField={labelField}
      labelRender={labelRender}
      preQuery={preQuery}
      searchFields={searchFields}
      sort={sort}
      pageSize={pageSize}
      multiple={false}
      value={value || null}
      placeholder="Search and select"
      disabled={disabled}
      clearable
      onChange={(next) => onChange(next ?? "")}
    />
  );
};

export default McaConditionRefValueInput;
